import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';
import { CreatePage } from '../create/create.page';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.page.html',
  styleUrls: ['./schedule.page.scss'],
})
export class SchedulePage implements OnInit {

  templates: any = null;
  grouped_templates: any[] = [];
  groups: any = null;
  loading = true;
  companies: any = null;
  contacts: any = null;
  has_changes = false;
  is_grouped = false;
  multi_select_mode = false;
  selected_group_keys: string[] = [];
  selected_schedule_guids: string[] = [];
  multi_select_confirm_text = '';

  constructor(private modalController: ModalController, public globalService: GlobalService, private apiService: ApiService, private alertController: AlertController) { }

  ngOnInit() {
    this.GetData();
  }

  async GetData(manual_refresh = false) {
    if(!manual_refresh) {
      this.multi_select_mode = !this.multi_select_mode;
      this.selected_group_keys = [];
    }
    this.loading = true;
    //await this.GetGroups();
    await this.GetCompanies();
    await this.GetContacts();
    await this.GetTemplates();
    //await this.RedrawGroups();
    this.loading = false;

  }

  async GetCompanies() {
    let data: any = await this.apiService.GetCompanies();
    if (data.success) {
      this.companies = data.data;
    }
  }

  async GetContacts() {
    let data: any = await this.apiService.GetClients();
    if (data.success) {
      this.contacts = data.data;
    }
  }


  async GetTemplates() {
    let data: any = await this.apiService.GetProjectSchedule('');
    if (data.success) {
      this.templates = data.data || [];
      this.FormatData();
    }
  }

  FormatData() {
    this.templates.forEach(template => {
      const template_data = JSON.parse(template.project_templates[0].json_str);
      template.tasks = template_data.tasks;
      template.tags = template_data.tags;
      template.groups = template_data.groups || [];
      template._repeat_rules_json = template.repeat_rules;
      template.repeat_rules = JSON.parse(template.repeat_rules);
      template.template_title = template_data.title || template.project_templates[0]?.title || '';
      template._template_json = template.project_templates[0]?.json_str || '';
      template.created_date = template.project_templates[0]?.created_date || null;
      template.last_modified_date = template.project_templates[0]?.last_modified_date || null;

      if (template.client_guid) {
        const contact = this.contacts.find(c => c.guid === template.client_guid);
        if (contact) template.display_name = contact.display_name;
      }
      if (template.company_guid) {
        const company = this.companies.find(c => c.guid === template.company_guid);
        if (company) template.company_display_name = company.name;
      }
      template.assigned_to_name = template.company_display_name || template.display_name || '';
    });
    this.BuildGroupedTemplates();
  }

  BuildGroupedTemplates() {
    const groupMap = new Map<string, any>();
    for (const template of this.templates) {
      //Since we dont allow the edit of repeat rules we dont care about them. If we did, they would need to be included in the grouping key and the edit page would need to allow editing of repeat rules and handle the consequences of that edit (ex. splitting groups if repeat rules are changed for some but not all schedules in a group)
      let template_title = template.template_title.trim();
      let json_for_key: any = {};
      try {
        json_for_key = JSON.parse(template._template_json.trim());
        delete json_for_key.schedule_guid;
        delete json_for_key.template_guid;
      } catch { json_for_key = {}; }
      const key = `${JSON.stringify(json_for_key)}${template_title}|${template._repeat_rules_json ?? ''}`;
      if (groupMap.has(key)) {
        const group = groupMap.get(key);
        if (template.assigned_to_name) group.display_names_array.push(template.assigned_to_name);
        group._schedules.push(template);
      } else {
        groupMap.set(key, {
          ...template,
          display_names_array: template.assigned_to_name ? [template.assigned_to_name] : [],
          _schedules: [template],
          _group_key: key
        });
      }
    }
    this.grouped_templates = Array.from(groupMap.values()).map(g => ({
      ...g,
      display_names_string: g.display_names_array.join(', ')
    }));
  }

  isValidScheduleDate(date: string): boolean {
    if (!date) return false;
    return new Date(date).getFullYear() > 1900;
  }

  isEndDateNever(end_date: string): boolean {
    const givenDate = new Date(end_date);
    const fifteenYearsFromNow = new Date();
    fifteenYearsFromNow.setFullYear(fifteenYearsFromNow.getFullYear() + 15);
    return givenDate > fifteenYearsFromNow;
  }

  async GetGroups() {
    let data: any = await this.apiService.GetGroups('projects');
    this.groups = data.data;
    if (!this.groups) this.groups = [];
  }

  async RedrawGroups() {

  }

  async Dismiss() {
    this.modalController.dismiss(this.has_changes);
  }

  async isDateOver15YearsAway(date: string) {
    const givenDate = new Date(date);
    const currentDate = new Date();
    const fifteenYearsFromNow = new Date();
    fifteenYearsFromNow.setFullYear(currentDate.getFullYear() + 15);
    return givenDate > fifteenYearsFromNow;
  }

  GetAssignedTo(schedule: any) {
    if(schedule.company_guid) {
      const company = this.companies.find(c => c.guid === schedule.company_guid);
      return company ? company.name : 'N/A';
    }
    else if (schedule.client_guid) {
      const contact = this.contacts.find(c => c.guid === schedule.client_guid);
      return contact ? contact.display_name : 'N/A';
    }
    return "";
  }

  async DeleteSchedule(schedule: any) {
    const alert = await this.alertController.create({
      backdropDismiss: false,
      header: 'Confirm Delete',
      message: `Type "${schedule.project_templates[0]?.title}" to confirm deletion.`,
      inputs: [
        {
          name: 'delete_type',
          type: 'radio',
          label: 'Future related not started Projects',
          value: '0'
        },
        {
          name: 'delete_type',
          type: 'radio',
          label: 'Unchanged related Future Projects',
          value: '1'
        },
        {
          name: 'delete_type',
          type: 'radio',
          label: 'All related Future Projects',
          value: '2',
          checked: true
        },
        {
          name: 'delete_type',
          type: 'radio',
          label: 'All related Future and Past Projects',
          value: '3'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Delete',
          role: 'confirm',
          handler: async (data: any) => {
            await this.globalService.presentLoading(`Deleting schedule for ${schedule.assigned_to_name || 'N/A'}...`,999999);
            let delete_data: any = await this.apiService.delete(`projects_schedule/${schedule.guid}`, { delete_type: data });
            await this.globalService.dismissLoading();
              if(delete_data.success) {
                this.has_changes = true;
                this.templates = this.templates.filter((t: any) => t.guid !== schedule.guid);
                this.BuildGroupedTemplates();
              }
              this.globalService.presentToastMessage(delete_data.message, delete_data.success);
              
          }
        }
      ]
    });
    await alert.present();
  }

  async EditTemplate(schedule: any) {
        const project = JSON.parse(schedule.project_templates[0].json_str);
        project.template_guid = schedule.project_templates[0].guid;
        project.schedule_guid = schedule.guid;
        const modal = await this.modalController.create({
          component: CreatePage,
          cssClass: 'large-modal secondary-modal',
          backdropDismiss: false,
          componentProps: {
            project,
            edit_template_mode: true,
            edit_schedule_mode: true,
            edit_all_related: false,
            grouped_schedules_info: []
          }
        });
        modal.onDidDismiss().then((data: any) => {
          if (data.data) { this.GetData(); this.has_changes = true; }
        });
        await modal.present();
      }

  async DeleteGroupedSchedule(group: any) {
    const alert = await this.alertController.create({
      backdropDismiss: false,
      header: 'Confirm Delete',
      message: `Delete all ${group._schedules.length} schedule(s) for "${group.template_title}"?`,
      inputs: [
        { name: 'delete_type', type: 'radio', label: 'Future related not started Projects', value: '0' },
        { name: 'delete_type', type: 'radio', label: 'Unchanged related Future Projects', value: '1' },
        { name: 'delete_type', type: 'radio', label: 'All related Future Projects', value: '2', checked: true },
        { name: 'delete_type', type: 'radio', label: 'All related Future and Past Projects', value: '3' }
      ],
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Delete All',
          role: 'confirm',
          handler: async (delete_type: any) => {
            for (const schedule of group._schedules) {
              await this.globalService.presentLoading(`Deleting schedule for ${schedule.assigned_to_name || 'N/A'}...`,999999);
              const delete_data: any = await this.apiService.delete(`projects_schedule/${schedule.guid}`, { delete_type });
              await this.globalService.dismissLoading();
              if (!delete_data.success) {
                this.globalService.presentToastMessage(delete_data.message, false);
                return;
              }
            }
            const deletedGuids = new Set(group._schedules.map((s: any) => s.guid));
            this.templates = this.templates.filter((t: any) => !deletedGuids.has(t.guid));
            this.BuildGroupedTemplates();
            this.has_changes = true;
            this.globalService.presentToastMessage(`${group._schedules.length} schedule(s) deleted.`, true);
          }
        }
      ]
    });
    await alert.present();
  }

  ToggleMultiSelectMode() {
    this.multi_select_mode = !this.multi_select_mode;
    if (!this.multi_select_mode) {
      this.selected_group_keys = [];
      this.selected_schedule_guids = [];
      this.multi_select_confirm_text = '';
    }
  }

  IsScheduleSelected(schedule: any): boolean {
    return this.selected_schedule_guids.includes(schedule.guid);
  }

  CanSelectSchedule(_schedule: any): boolean {
    return true;
  }

  ToggleScheduleSelection(schedule: any) {
    const idx = this.selected_schedule_guids.indexOf(schedule.guid);
    if (idx > -1) {
      this.selected_schedule_guids.splice(idx, 1);
    } else {
      this.selected_schedule_guids.push(schedule.guid);
    }
    this.multi_select_confirm_text = '';
  }

  SelectedSchedulesHaveDifferentTitles(): boolean {
    const selected = this.GetSelectedSchedules();
    if (selected.length < 2) return false;
    const first = selected[0].template_title.trim();
    return selected.some((s: any) => s.template_title.trim() !== first);
  }

  IsScheduleEditBlocked(schedule: any): boolean {
    return this.multi_select_mode
      && this.IsScheduleSelected(schedule)
      && this.selected_schedule_guids.length > 1
      && this.SelectedSchedulesHaveDifferentTitles()
      && this.multi_select_confirm_text.trim().toLowerCase() !== 'understand';
  }


  GetSelectedScheduleTitleList(): string[] {
    return Array.from(new Set(this.GetSelectedSchedules().map((s: any) => s.template_title.trim())));
  }

  GetSelectedSchedules(): any[] {
    return this.templates.filter((t: any) => this.selected_schedule_guids.includes(t.guid));
  }

  SelectedSchedulesHaveDifferentTemplates(): boolean {
    const selected = this.GetSelectedSchedules();
    if (selected.length < 2) return false;
    const first = selected[0]._template_json;
    return selected.some((s: any) => s._template_json !== first);
  }

  SelectedSchedulesHaveDifferentRepeatRules(): boolean {
    const selected = this.GetSelectedSchedules();
    if (selected.length < 2) return false;
    const first = selected[0]._repeat_rules_json;
    return selected.some((s: any) => s._repeat_rules_json !== first);
  }

  GetScheduleTemplateDifferences(): string[] {
    const selected = this.GetSelectedSchedules();
    if (selected.length < 2) return [];
    const templates = selected.map((s: any) => JSON.parse(s._template_json));
    const diffs = new Set<string>();
    const allTaskTitles = new Set<string>();
    templates.forEach(t => (t.tasks || []).forEach((task: any) => allTaskTitles.add(task.title)));
    allTaskTitles.forEach(title => {
      const matchingTasks = templates.map(t => (t.tasks || []).find((tk: any) => tk.title === title));
      if (matchingTasks.some(tk => !tk)) {
        diffs.add(`Task "${title}" is not present in all selected schedules`);
      } else {
        const allStepTitles = new Set<string>();
        matchingTasks.forEach(tk => (tk.steps || []).forEach((s: any) => allStepTitles.add(s.title)));
        allStepTitles.forEach(stepTitle => {
          if (matchingTasks.some(tk => !(tk.steps || []).find((s: any) => s.title === stepTitle))) {
            diffs.add(`Step "${stepTitle}" in task "${title}" is not present in all selected schedules`);
          }
        });
      }
    });
    return Array.from(diffs);
  }

  GetScheduleRepeatRuleDifferences(): string[] {
    const selected = this.GetSelectedSchedules();
    if (selected.length < 2) return [];
    const rules = selected.map((s: any) => s.repeat_rules);
    const diffs: string[] = [];
    ['frequency', 'interval', 'end_type', 'end_date', 'pattern'].forEach(key => {
      const values = rules.map(r => JSON.stringify(r[key]));
      if (new Set(values).size > 1) diffs.push(key);
    });
    return diffs;
  }

  async EditMultiSelectedSchedules(base_schedule: any) {
    const selected = this.GetSelectedSchedules();
    if (!this.IsScheduleSelected(base_schedule) || selected.length <= 1) {
      await this.EditTemplate(base_schedule);
      return;
    }
    if (this.SelectedSchedulesHaveDifferentTitles() && this.multi_select_confirm_text.trim().toLowerCase() !== 'understand') {
      this.globalService.presentToastMessage('Type "understand" in the confirmation box above before editing schedules with different project names.', false);
      return;
    }
    const project = JSON.parse(base_schedule.project_templates[0].json_str);
    project.template_guid = base_schedule.project_templates[0].guid;
    project.schedule_guid = base_schedule.guid;
    const grouped_schedules_info = selected.map((s: any) => ({
      guid: s.guid,
      template_guid: s.project_templates[0].guid,
      assigned_to_name: s.assigned_to_name || 'Unknown',
      start_date: s.start_date,
      end_date: s.end_date
    }));
    const modal = await this.modalController.create({
      component: CreatePage,
      cssClass: 'large-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        project,
        edit_template_mode: true,
        edit_schedule_mode: true,
        edit_all_related: true,
        grouped_schedules_info,
        repeat_rule_update_disabled: this.SelectedSchedulesHaveDifferentRepeatRules()
      }
    });
    modal.onDidDismiss().then((data: any) => {
      if (data.data) { this.GetData(); this.has_changes = true; }
    });
    await modal.present();
  }

  IsGroupSelected(group: any): boolean {
    return this.selected_group_keys.includes(group._group_key);
  }

  CanSelectGroup(_group: any): boolean {
    return true;
  }

  ToggleGroupSelection(group: any) {
    const idx = this.selected_group_keys.indexOf(group._group_key);
    if (idx > -1) {
      this.selected_group_keys.splice(idx, 1);
    } else {
      this.selected_group_keys.push(group._group_key);
    }
    this.multi_select_confirm_text = '';
  }

  SelectedGroupsHaveDifferentTitles(): boolean {
    const selected = this.GetSelectedGroups();
    if (selected.length < 2) return false;
    const first = selected[0].template_title.trim();
    return selected.some(g => g.template_title.trim() !== first);
  }

  IsGroupEditBlocked(group: any): boolean {
    return this.multi_select_mode
      && this.IsGroupSelected(group)
      && this.selected_group_keys.length > 1
      && this.SelectedGroupsHaveDifferentTitles()
      && this.multi_select_confirm_text.trim().toLowerCase() !== 'understand';
  }


  GetSelectedGroupTitleList(): string[] {
    return Array.from(new Set(this.GetSelectedGroups().map(g => g.template_title.trim())));
  }

  GetSelectedGroups(): any[] {
    return this.grouped_templates.filter(g => this.selected_group_keys.includes(g._group_key));
  }

  GetSelectedScheduleCount(): number {
    return this.GetSelectedGroups().reduce((sum, g) => sum + g._schedules.length, 0);
  }

  SelectedGroupsHaveDifferentTemplates(): boolean {
    const selected = this.GetSelectedGroups();
    if (selected.length < 2) return false;
    const first = selected[0]._template_json;
    return selected.some(g => g._template_json !== first);
  }

  SelectedGroupsHaveDifferentRepeatRules(): boolean {
    const selected = this.GetSelectedGroups();
    if (selected.length < 2) return false;
    const first = selected[0]._repeat_rules_json;
    return selected.some(g => g._repeat_rules_json !== first);
  }

  // How many rows are ticked in whichever view (grouped or ungrouped) is currently showing
  GetSelectedRowCount(): number {
    return this.is_grouped ? this.selected_group_keys.length : this.selected_schedule_guids.length;
  }

  // Bulk delete is only offered once more than one row is ticked. Typing "understand" happens inside the
  // confirmation dialog itself (DeleteSelected), separate from the "understand" box the multi-edit
  // warnings above use.
  CanDeleteSelected(): boolean {
    return this.multi_select_mode && this.GetSelectedRowCount() > 1;
  }

  // The individual schedules behind whatever is ticked - a ticked group stands in for every schedule in it
  private GetSelectedScheduleList(): any[] {
    return this.is_grouped
      ? ([] as any[]).concat(...this.GetSelectedGroups().map((g: any) => g._schedules))
      : this.GetSelectedSchedules();
  }

  async DeleteSelected() {
    if (!this.CanDeleteSelected()) return;
    const schedules = this.GetSelectedScheduleList();
    if (schedules.length === 0) return;

    // Say exactly what's about to go, not just a count - cap the visible list so a huge selection doesn't
    // produce an unreadable wall of text.
    const LIST_LIMIT = 15;
    const listed = schedules.slice(0, LIST_LIMIT)
      .map((s: any) => `<li><strong>${s.assigned_to_name || 'Unknown'}</strong> — ${s.template_title || 'Untitled template'}</li>`)
      .join('');
    const remaining = schedules.length - LIST_LIMIT;
    const message = `<strong>This cannot be undone.</strong> You are about to permanently delete the following ${schedules.length} schedule(s), and their related projects per the option below:` +
      `<ul class="mb-1 mt-2">${listed}</ul>` +
      (remaining > 0 ? `<div>...and ${remaining} more.</div>` : '');

    const alert = await this.alertController.create({
      backdropDismiss: false,
      header: 'Confirm Delete',
      message,
      inputs: [
        { name: 'delete_type', type: 'radio', label: 'Future related not started Projects', value: '0' },
        { name: 'delete_type', type: 'radio', label: 'Unchanged related Future Projects', value: '1' },
        { name: 'delete_type', type: 'radio', label: 'All related Future Projects', value: '2', checked: true },
        { name: 'delete_type', type: 'radio', label: 'All related Future and Past Projects', value: '3' }
      ],
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: `Delete ${schedules.length}`,
          role: 'confirm',
          handler: async (delete_type: any) => {
            const deleted_guids = new Set<string>();
            let failed = 0;
            for (let i = 0; i < schedules.length; i++) {
              const schedule = schedules[i];
              await this.globalService.presentLoading(`Deleting ${i + 1} of ${schedules.length} (${schedule.assigned_to_name || 'N/A'})...`, 999999);
              const delete_data: any = await this.apiService.delete(`projects_schedule/${schedule.guid}`, { delete_type });
              await this.globalService.dismissLoading();
              if (delete_data.success) deleted_guids.add(schedule.guid);
              else failed++;
            }
            this.templates = this.templates.filter((t: any) => !deleted_guids.has(t.guid));
            this.BuildGroupedTemplates();
            if (deleted_guids.size > 0) this.has_changes = true;
            this.selected_group_keys = [];
            this.selected_schedule_guids = [];
            this.globalService.presentToastMessage(
              failed === 0
                ? `${deleted_guids.size} schedule(s) deleted.`
                : `${deleted_guids.size} of ${schedules.length} schedule(s) deleted. ${failed} failed - please try again.`,
              failed === 0
            );
          }
        }
      ]
    });
    await alert.present();
  }

  GetTemplateDifferences(): string[] {
    const selected = this.GetSelectedGroups();
    if (selected.length < 2) return [];
    const templates = selected.map(g => JSON.parse(g._template_json));
    const diffs = new Set<string>();
    const allTaskTitles = new Set<string>();
    templates.forEach(t => (t.tasks || []).forEach((task: any) => allTaskTitles.add(task.title)));
    allTaskTitles.forEach(title => {
      const matchingTasks = templates.map(t => (t.tasks || []).find((tk: any) => tk.title === title));
      if (matchingTasks.some(tk => !tk)) {
        diffs.add(`Task "${title}" is not present in all selected groups`);
      } else {
        const allStepTitles = new Set<string>();
        matchingTasks.forEach(tk => (tk.steps || []).forEach((s: any) => allStepTitles.add(s.title)));
        allStepTitles.forEach(stepTitle => {
          if (matchingTasks.some(tk => !(tk.steps || []).find((s: any) => s.title === stepTitle))) {
            diffs.add(`Step "${stepTitle}" in task "${title}" is not present in all selected groups`);
          }
        });
      }
    });
    return Array.from(diffs);
  }

  GetRepeatRuleDifferences(): string[] {
    const selected = this.GetSelectedGroups();
    if (selected.length < 2) return [];
    const rules = selected.map(g => g.repeat_rules);
    const diffs: string[] = [];
    const keys = ['frequency', 'interval', 'end_type', 'end_date', 'pattern'];
    keys.forEach(key => {
      const values = rules.map(r => JSON.stringify(r[key]));
      if (new Set(values).size > 1) diffs.push(key);
    });
    return diffs;
  }

  async EditMultiSelectedGroups(base_group: any) {
    const selected = this.GetSelectedGroups();
    if (!this.IsGroupSelected(base_group) || selected.length <= 1) {
      await this.EditGroupedTemplate(base_group);
      return;
    }
    if (this.SelectedGroupsHaveDifferentTitles() && this.multi_select_confirm_text.trim().toLowerCase() !== 'understand') {
      this.globalService.presentToastMessage('Type "understand" in the confirmation box above before editing groups with different project names.', false);
      return;
    }
    const schedule = base_group._schedules[0];
    const project = JSON.parse(schedule.project_templates[0].json_str);
    project.template_guid = schedule.project_templates[0].guid;
    project.schedule_guid = schedule.guid;
    const all_schedules: any[] = [].concat(...selected.map((g: any) => g._schedules));
    const grouped_schedules_info = all_schedules.map((s: any) => ({
      guid: s.guid,
      template_guid: s.project_templates[0].guid,
      assigned_to_name: s.assigned_to_name || 'Unknown',
      start_date: s.start_date,
      end_date: s.end_date
    }));
    const modal = await this.modalController.create({
      component: CreatePage,
      cssClass: 'large-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        project,
        edit_template_mode: true,
        edit_schedule_mode: true,
        edit_all_related: true,
        grouped_schedules_info,
        repeat_rule_update_disabled: this.SelectedGroupsHaveDifferentRepeatRules()
      }
    });
    modal.onDidDismiss().then((data: any) => {
      if (data.data) { this.GetData(); this.has_changes = true; }
    });
    await modal.present();
  }

  async EditGroupedTemplate(group: any) {
        const schedule = group._schedules[0];
        const project = JSON.parse(schedule.project_templates[0].json_str);
        project.template_guid = schedule.project_templates[0].guid;
        project.schedule_guid = schedule.guid;
        const grouped_schedules_info = group._schedules.map((s: any) => ({
          guid: s.guid,
          template_guid: s.project_templates[0].guid,
          assigned_to_name: s.assigned_to_name || 'Unknown',
          start_date: s.start_date,
          end_date: s.end_date
        }));
        const modal = await this.modalController.create({
          component: CreatePage,
          cssClass: 'large-modal secondary-modal',
          backdropDismiss: false,
          componentProps: {
            project,
            edit_template_mode: true,
            edit_schedule_mode: true,
            edit_all_related: true,
            grouped_schedules_info
          }
        });
        modal.onDidDismiss().then((data: any) => {
          if (data.data) { this.GetData(); this.has_changes = true; }
        });
        await modal.present();
      }

      


}